
export default function ContactSection() {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Póngase en Contacto
          </h3>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            ¿Tiene preguntas o necesita asistencia inmediata? Nuestro equipo está aquí para ayudarle 24/7
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {/* Phone */}
          <div className="bg-gradient-to-br from-uri-teal/10 to-uri-teal/5 rounded-2xl p-8 text-center hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-uri-teal rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-phone-line text-3xl text-white"></i>
            </div>
            <h4 className="font-bold text-gray-900 text-xl mb-2">Llámenos</h4>
            <p className="text-sm text-gray-600 mb-4">Disponible 24/7 para emergencias</p>
            <a href="tel:+584143363083" className="text-lg font-bold text-uri-teal hover:text-uri-teal-dark transition-colors">
              +58 414 336 3083
            </a>
          </div>

          {/* WhatsApp */}
          <div className="bg-gradient-to-br from-uri-blue/10 to-uri-blue/5 rounded-2xl p-8 text-center hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-[#25D366] rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-whatsapp-line text-3xl text-white"></i>
            </div>
            <h4 className="font-bold text-gray-900 text-xl mb-2">WhatsApp</h4>
            <p className="text-sm text-gray-600 mb-4">Escríbanos por WhatsApp ahora</p>
            <a
              href="https://wa.me/584143363083"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-[#25D366] text-white font-semibold rounded-lg hover:bg-[#1ebe5d] transition-colors text-sm whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line"></i>
              Iniciar Chat
            </a>
          </div>

          {/* Chat */}
          <div className="bg-gradient-to-br from-uri-green/10 to-uri-green/5 rounded-2xl p-8 text-center hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-uri-green rounded-2xl flex items-center justify-center mx-auto mb-4">
              <i className="ri-chat-3-line text-3xl text-white"></i>
            </div>
            <h4 className="font-bold text-gray-900 text-xl mb-2">Chat en Vivo</h4>
            <p className="text-sm text-gray-600 mb-4">Chatee con nuestro asistente ahora</p>
            <button 
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.dispatchEvent(new Event('click'))}
              className="text-lg font-bold text-uri-green hover:text-uri-green-dark transition-colors cursor-pointer whitespace-nowrap"
            >
              Iniciar Chat
            </button>
          </div>
        </div>

        {/* Emergency Notice */}
        <div className="mt-12 max-w-3xl mx-auto bg-red-50 border-2 border-red-200 rounded-2xl p-6">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-alarm-warning-line text-2xl text-white"></i>
            </div>
            <div>
              <h4 className="font-bold text-red-900 text-lg mb-2">¿Emergencia Médica?</h4>
              <p className="text-sm text-red-800 mb-3">
                Si usted o su ser querido está experimentando una emergencia médica, por favor llame al 911 inmediatamente o vaya a la sala de emergencias más cercana. Nuestros servicios son para asistencia de salud no urgente.
              </p>
              <a href="tel:911" className="inline-flex items-center gap-2 px-4 py-2 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-colors text-sm whitespace-nowrap">
                <i className="ri-phone-line"></i>
                Llamar al 911
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
